import PropTypes from 'prop-types';
import { Chip } from '@mui/material';
import { COMP_OFF_STATUS_COLORS, COMP_OFF_STATUS_LABELS } from '../constants';

const CompOffStatusBadge = ({ status }) => (
  <Chip label={COMP_OFF_STATUS_LABELS[status] || status} color={COMP_OFF_STATUS_COLORS[status] || 'default'} size="small" />
);

CompOffStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default CompOffStatusBadge;
